export const routePaths = {
  clinicManagement: "/clinicManagement",
  editclinicDetails: "/editClinicDetails",
  viewClinicDetails: "/viewClinicDetails",
  login: "/login",
  otp: "/otp",
  setPassword: "/setPassword",
  register: "/register",
  base: "/",
  wild: "*",
};
